import { Switch, Route as RouteReact } from 'react-router-dom';

import Route from './Route';
import SignIn from '../pages/SignIn';
import { URI } from '../contracts/enums';
import { ExamProvider } from '../contexts/exam';
import React, { lazy } from 'react';
import VideoTemplate from '../templates/video';
import { LessonProvider } from '../contexts/lesson';
import { TutoringProvider } from '../contexts/tutoring';
import PDFTemplate from '../templates/pdf';
import { HandoutProvider } from '../contexts/handout';
import { ChapterProvder } from '../contexts/chapter';
import { ExamResolutionProvider } from '../contexts/examResolution';
import { HandoutResolutionProvider } from '../contexts/handoutResolution';
import { LongExamProvider } from '../contexts/longExam';
import { LongExamResolutionProvider } from '../contexts/longExamResolution';
import { ExtraClassProvider } from '../contexts/extraClass';
import { ExtraContentProvider } from '../contexts/extraContent';
import PremiumRoute from './PremiumRoute';

function RoutesComponent() {
  return (
    <Switch>
      <Route path={URI.base} exact component={SignIn} />
      <Switch>
        <RouteReact path={URI.dashboard}>
          <Switch>
            <ChapterProvder>
              <Route path={URI.dashboard} component={lazy(() => import('../pages/Dashboard'))} isPrivate />
            </ChapterProvder>
          </Switch>
        </RouteReact>
        <Route path={URI.statistics} component={lazy(() => import('../pages/Statistics'))} isPrivate />
        <PremiumRoute path={URI.exams} isPrivate>
          <PDFTemplate>
            <ExamProvider>
              <Switch>
                <Route path={URI.examAnswer} component={lazy(() => import('../pages/ExamAnswer'))} isPrivate />
                <Route path={URI.examResults} component={lazy(() => import('../pages/ExamResults'))} isPrivate />|
                <Route path={URI.exams} component={lazy(() => import('../pages/Exams'))} isPrivate />
              </Switch>
            </ExamProvider>
          </PDFTemplate>
        </PremiumRoute>
        <RouteReact path={URI.lessons}>
          <VideoTemplate>
            <ChapterProvder>
              <LessonProvider>
                <Route path={URI.lessons} component={lazy(() => import('../pages/Lessons'))} isPrivate />
              </LessonProvider>
            </ChapterProvder>
          </VideoTemplate>
        </RouteReact>
        <PremiumRoute path={URI.monitoria} isPrivate>
          <VideoTemplate>
            <TutoringProvider>
              <Route path={URI.monitoria} component={lazy(() => import('../pages/Monitoria'))} isPrivate />
            </TutoringProvider>
          </VideoTemplate>
        </PremiumRoute>
        <RouteReact path={URI.clinicalCase}>
          <VideoTemplate>
            <TutoringProvider>
              <Route path={URI.clinicalCase} component={lazy(() => import('../pages/ClinicCases'))} isPrivate />
            </TutoringProvider>
          </VideoTemplate>
        </RouteReact>
        <PremiumRoute path={URI.digitalMaterial} isPrivate>
          <Switch>
            <RouteReact path={URI.handout}>
              <PDFTemplate>
                <HandoutProvider>
                  <Route path={URI.handout} component={lazy(() => import('../pages/DigitalMaterial/Handout'))} isPrivate />
                </HandoutProvider>
              </PDFTemplate>
            </RouteReact>
            <RouteReact path={URI.examResolution}>
              <VideoTemplate>
                <ExamResolutionProvider>
                  <Route path={URI.examResolutionParams} component={lazy(() => import('../pages/DigitalMaterial/ExamResolution'))} isPrivate />
                  <Route exact path={URI.examResolution} component={lazy(() => import('../pages/DigitalMaterial/ExamResolution'))} isPrivate />
                </ExamResolutionProvider>
              </VideoTemplate>
            </RouteReact>
            <RouteReact path={URI.handoutResolution}>
              <VideoTemplate>
                <HandoutResolutionProvider>
                  <Route path={URI.handoutResolutionParams} component={lazy(() => import('../pages/DigitalMaterial/HandoutResolution'))} isPrivate />
                  <Route exact path={URI.handoutResolution} component={lazy(() => import('../pages/DigitalMaterial/HandoutResolution'))} isPrivate />
                </HandoutResolutionProvider>
              </VideoTemplate>
            </RouteReact>
            <RouteReact path={URI.longExam}>
              <PDFTemplate>
                <LongExamProvider>
                  <Route exact path={URI.longExam} component={lazy(() => import('../pages/DigitalMaterial/LongExam'))} isPrivate />
                  <Route path={URI.longExamAnswers} component={lazy(() => import('../pages/DigitalMaterial/LongExam/answer'))} isPrivate />
                  <Route path={URI.longExamResults} component={lazy(() => import('../pages/DigitalMaterial/LongExam/result'))} isPrivate />
                </LongExamProvider>
              </PDFTemplate>
            </RouteReact>
            <RouteReact path={URI.longExamResolution}>
              <VideoTemplate>
                <LongExamResolutionProvider>
                  <Route path={URI.longExamResolutionParams} component={lazy(() => import('../pages/DigitalMaterial/LongExamResolution'))} isPrivate />
                  <Route exact path={URI.longExamResolution} component={lazy(() => import('../pages/DigitalMaterial/LongExamResolution'))} isPrivate />
                </LongExamResolutionProvider>
              </VideoTemplate>
            </RouteReact>
            <RouteReact path={URI.extraLessons}>
              <VideoTemplate>
                <ExtraClassProvider>
                  <Route path={URI.extraLessons} component={lazy(() => import('../pages/DigitalMaterial/ExtraLessons'))} isPrivate />
                </ExtraClassProvider>
              </VideoTemplate>
            </RouteReact>
            <RouteReact path={URI.extraContent}>
              <PDFTemplate>
                <ExtraContentProvider>
                  <Route path={URI.extraContent} component={lazy(() => import('../pages/DigitalMaterial/ExtraContent'))} isPrivate />
                </ExtraContentProvider>
              </PDFTemplate>
            </RouteReact>
          </Switch>
        </PremiumRoute>
        <RouteReact path={URI.chapter}>
          <ChapterProvder>
            <ExamProvider>
              <Route path={URI.chapter} component={lazy(() => import('../pages/Chapter'))} isPrivate></Route>
            </ExamProvider>
          </ChapterProvder>
        </RouteReact>
      </Switch>
    </Switch>
  );
}

export default RoutesComponent;
